module.exports = __webpack_public_path__ + "img/centurion-hpb-ar.96bb4af0.jpg";